<template>
	<!-- <content-head title="Home" /> -->
	<heading />
	<content class="">
		<div class="row">
			<div
				class="card custom-card bg-light col-xl-12 rounded-0 border-0 shadow"
			>
				<div class="row card-title pb-0 px-2 pt-2">
					<div class="row d-none">
						<div class="col-12 float-sm-left text-start">
							<h4 class="m-0 text-dark" style="font-family: NunitoBlack">
								<i class="nav-icon fas fa-paw"></i>
								Budgeting&nbsp;&nbsp;
							</h4>
						</div>
					</div>

					<div class="col-12">
						<div
							class="page-title-box d-sm-flex align-items-center justify-content-between nunito-black"
						>
							<div class="page-title-left">
								<ol class="breadcrumb m-0">
									<li class="breadcrumb-item">
										<a href="">
											<span
												class="badge rounded-pill bg-green-custom text-white font-size-15"
												>&nbsp;&nbsp;&nbsp;<i class="nav-icon fas fa-paw"></i
												>&nbsp;&nbsp;Operations&nbsp;&nbsp;&nbsp;</span
											>
										</a>
									</li>

									<li class="active">&nbsp;&nbsp;Budgeting&nbsp;&nbsp;</li>
								</ol>
							</div>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0 pt-0">
					<div class="row">
						<div class="col-xl-12">
							<div class="card card-body p-4 text-dark">
								<div class="row mb-1 d-flex p-2">
									<div class="col-md-12">
										<div class="mb-1">
											<label for="agent_id" class="form-label"
												>Select Registered Tour</label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												return-object
												placeholder="Select Registerd Tour"
												:items="infiniteTours.data || []"
												v-model="filterBudgets.tour"
												@update:modelValue="selectTour($event)"
												:item-title="tourSelect"
												item-value="id"
												clearable
											>
											</v-autocomplete>
										</div>
									</div>
									<div
										class="col-md-3 justify-content-start align-items-center gap-2 d-none"
										style="font-family: HeaderCustomFont"
									>
										<button
											type="submit"
											id="Filter"
											class="btn btn-info rounded-0 text-white"
										>
											<i class="nav-icon fas fa-filter"></i>&nbsp;&nbsp;Filter
										</button>
										<button
											type="button"
											id="Export"
											class="btn btn-danger rounded-0 text-white"
										>
											<i class="nav-icon fas fa-window-close"></i
											>&nbsp;&nbsp;Clear
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="row card-body mt-0">
					<div class="row">
						<div class="col-xl-12">
							<div class="card card-body p-4 text-dark">
								<div class="row col-sm-12">
									<div class="col-sm-7 float-sm-left text-start"></div>
									<div
										class="col-sm-5 text-end"
										style="font-family: HeaderCustomFont"
									>
										<button
											class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
											@click="openModal('budgets')"
										>
											<i class="nav-icon fas fa-plus"></i>&nbsp;&nbsp;Tour
											Budget
										</button>
									</div>
								</div>
								<div class="row col-sm-12 mt-2">
									<div class="table-responsive p-1">
										<v-text-field
											v-model="searchBudgeting"
											label="Search Tour Budgets"
											prepend-inner-icon="mdi-magnify"
											flat
											rounded="0"
											variant="outlined"
											density="compact"
											class="d-none"
										></v-text-field>
										<v-data-table
											v-model:items-per-page="budgetPerPage"
											:headers="budgetHeaders"
											:items="budgetsComputed"
											:search="searchBudgeting"
											density="compact"
											item-value="id"
											class="table-sm table-striped rounded-0 text-truncate table-nowrap"
										>
											<template v-slot:body="{ items }">
												<tr
													v-for="(item, index) in items"
													:key="item.id"
													@click="selectBudget(item)"
													class="clickable-row"
													:class="{
														'selected-row':
															selectedBudget && item.id === selectedBudget.id,
													}"
												>
													<td>{{ index + 1 }}</td>
													<td>
														{{ item.tour ? item.tour.reference_number : "N/A" }}
													</td>
													<td>{{ item.total_amount }}</td>
													<td>{{ item.status }}</td>
													<td class="">
														<v-menu offset-y>
															<template v-slot:activator="{ props }">
																<v-icon v-bind="props" size="24">
																	mdi-dots-horizontal
																</v-icon>
															</template>
															<v-list density="compact" class="custom-dropdown">
																<v-list-item
																	@click.stop="manageBudgets(item, 'edit')"
																>
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-regular fa-pen-to-square"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																	>
																</v-list-item>
																<v-list-item
																	@click.stop="manageBudgets(item, 'delete')"
																>
																	<v-list-item-title
																		><font-awesome-icon
																			icon="fa-solid fa-trash"
																		/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																	>
																</v-list-item>
															</v-list>
														</v-menu>
													</td>
												</tr>
											</template>
										</v-data-table>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- </div> -->
				</div>

				<div class="row card-body mt-0 p-4">
					<div class="row">
						<div class="col-xl-12">
							<v-expansion-panels v-model="openPanels.optionalCosts">
								<v-expansion-panel expand>
									<v-expansion-panel-title
										density="compact"
										class="compact-header text-dark rounded-0"
									>
										Budget Items
									</v-expansion-panel-title>
									<v-expansion-panel-text>
										<div class="card card-body accordion-body text-dark">
											<div class="row col-sm-12">
												<div class="col-sm-7 float-sm-left text-start"></div>
												<div
													class="col-sm-5 text-end"
													style="font-family: HeaderCustomFont"
												>
													<!-- @click="openModal(modal, data)" -->
													<button
														v-if="selectedBudget"
														class="btn text-none bg-green-custom float-sm-right text-white rounded-0"
														@click="openModal('items')"
													>
														<i class="nav-icon fas fa-plus"></i
														>&nbsp;&nbsp;Budget Item
													</button>
												</div>
											</div>
											<div class="row col-sm-12 mt-2">
												<div class="table-responsive p-1">
													<v-text-field
														v-model="searchItems"
														label="Search Budget Items"
														prepend-inner-icon="mdi-magnify"
														flat
														rounded="0"
														variant="outlined"
														density="compact"
														class="d-none"
													></v-text-field>
													<v-data-table
														v-model:items-per-page="itemsPerPage"
														:headers="itemHeaders"
														:items="filteredItems"
														:search="searchItems"
														density="compact"
														item-value="id"
														class="table-sm table-striped rounded-0 text-truncate table-nowrap"
													>
														<template v-slot:body="{ items }">
															<tr v-for="(item, index) in items" :key="item.id">
																<td>{{ index + 1 }}</td>
																<td>
																	{{
																		item.category ? item.category.name : "N/A"
																	}}
																</td>
																<td>{{ item.description }}</td>
																<td>{{ item.amount }}</td>
																<td>{{ item.currency }}</td>
																<td>{{ formatDate(item.date_required) }}</td>
																<td class="">
																	<v-menu offset-y>
																		<template v-slot:activator="{ props }">
																			<v-icon v-bind="props" size="24">
																				mdi-dots-horizontal
																			</v-icon>
																		</template>
																		<v-list
																			density="compact"
																			class="custom-dropdown"
																		>
																			<v-list-item
																				@click="manageItems(item, 'edit')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-regular fa-pen-to-square"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Edit</v-list-item-title
																				>
																			</v-list-item>
																			<v-list-item
																				@click="manageItems(item, 'delete')"
																			>
																				<v-list-item-title
																					><font-awesome-icon
																						icon="fa-solid fa-trash"
																					/>&nbsp;&nbsp;&nbsp;&nbsp;Delete</v-list-item-title
																				>
																			</v-list-item>
																		</v-list>
																	</v-menu>
																</td>
															</tr>
														</template>
													</v-data-table>
												</div>
											</div>
										</div>
									</v-expansion-panel-text>
								</v-expansion-panel>
							</v-expansion-panels>
							<!-- </div> -->
							<!-- </div> -->
						</div>
					</div>
				</div>
			</div>

			<v-dialog v-model="budgetModal" max-width="1000px" persistent>
				<v-card>
					<form
						@submit.prevent="
							editMode
								? manageBudgets(this.tourBudget, 'update')
								: manageBudgets(this.tourBudget, 'insert')
						"
					>
						<v-card-title class="d-flex justify-space-between align-center">
							<div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon icon="fas fa-handshake" />&nbsp;&nbsp;Tour
									Budget
								</h5>
							</div>
							<v-icon @click="closeModal('budgets')">mdi-close</v-icon>
						</v-card-title>
						<!-- Dialog Content -->
						<v-card-text>
							<div class="modal-body p-4">
								<div
									id="preloader d-none"
									class="col-sm-2 p-5"
									v-if="this.processing"
								>
									<div id="status">
										<div class="spinner-chase text-start">
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
										</div>
									</div>
								</div>
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-12 required">
											<div class="">
												<label for="client_id" class="form-label"
													><span
														v-if="tourBudget.errors.has('tour_id')"
														class="text-danger text-lowercase"
													>
														{{ tourBudget.errors.get("tour_id") }} </span
													><span v-else>Select Tour</span></label
												>
												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													return-object
													placeholder="Select Tour"
													:items="this.infiniteTours.data"
													v-model="tourBudget.tour_id"
													item-value="id"
													item-title="name"
													id="tour_id"
												>
												</v-autocomplete>
											</div>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-6 required">
											<label for="amount" class="form-label"
												><span
													v-if="tourBudget.errors.has('amount')"
													class="text-danger text-lowercase"
												>
													{{ tourBudget.errors.get("amount") }} </span
												><span v-else>Amount</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Total Budget Amount"
												v-model="tourBudget.amount"
												id="amount"
											></v-text-field>
										</div>
										<div class="col-md-3 required">
											<label for="status" class="form-label"
												><span
													v-if="tourBudget.errors.has('status')"
													class="text-danger text-lowercase"
												>
													{{ tourBudget.errors.get("status") }} </span
												><span v-else>Status</span></label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Select Budget Status"
												:items="[
													'draft',
													'submitted',
													'reviewed',
													'approved',
													'rejected',
												]"
												v-model="tourBudget.status"
												id="payt_category"
											>
											</v-autocomplete>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('budgets')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
							<!-- <v-btn color="primary" @click="tourModal = false">Close</v-btn> -->
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>

			<v-dialog v-model="itemModal" max-width="1000px" persistent>
				<v-card>
					<form
						@submit.prevent="
							editMode
								? manageItems(this.budgetItem, 'update')
								: manageItems(this.budgetItem, 'insert')
						"
					>
						<v-card-title class="d-flex justify-space-between align-center">
							<div class="modal-header">
								<!-- <slot name="header">default header</slot> -->
								<h5
									class="modal-title font-size-20 text-dark"
									style="font-family: HeaderCustomFont"
								>
									<font-awesome-icon
										icon="fas fa-handshake"
									/>&nbsp;&nbsp;Budget Item
								</h5>
							</div>
							<v-icon @click="closeModal('items')">mdi-close</v-icon>
						</v-card-title>
						<!-- Dialog Content -->
						<v-card-text>
							<div class="modal-body p-4">
								<div
									id="preloader d-none"
									class="col-sm-2 p-5"
									v-if="this.processing"
								>
									<div id="status">
										<div class="spinner-chase text-start">
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
											<div class="chase-dot"></div>
										</div>
									</div>
								</div>
								<div class="text-start">
									<div class="row mt-1">
										<div class="col-md-8 required">
											<div class="">
												<label for="client_id" class="form-label"
													><span
														v-if="budgetItem.errors.has('budget_id')"
														class="text-danger text-lowercase"
													>
														{{ budgetItem.errors.get("budget_id") }} </span
													><span v-else>Select Budget</span></label
												>
												<v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													return-object
													placeholder="Select Tour"
													:items="this.infiniteBudgets.data"
													v-model="budgetItem.budget_id"
													item-value="id"
													item-title="name"
													id="budget_id"
												>
												</v-autocomplete>
											</div>
										</div>

										<div class="col-md-4 required">
											<label for="category" class="form-label"
												><span
													v-if="budgetItem.errors.has('category')"
													class="text-danger text-lowercase"
												>
													{{ budgetItem.errors.get("category") }} </span
												><span v-else>Expense Category</span></label
											>
											<v-autocomplete
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												return-object
												placeholder="Select Expense Category"
												:items="this.infiniteTypes.data"
												v-model="budgetItem.category"
												item-value="id"
												item-title="name"
												id="category"
											>
											</v-autocomplete>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-5 required">
											<label for="amount" class="form-label"
												><span
													v-if="budgetItem.errors.has('amount')"
													class="text-danger text-lowercase"
												>
													{{ budgetItem.errors.get("amount") }} </span
												><span v-else>Item Amount</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Item Budget Amount"
												v-model="budgetItem.amount"
												id="amount"
											></v-text-field>
										</div>
										<div class="col-md-3 required">
											<div class="">
												<label for="name" class="form-label"
													><span
														v-if="budgetItem.errors.has('currency')"
														class="text-danger text-lowercase"
													>
														{{ budgetItem.errors.get("currency") }} </span
													><span v-else>Currency</span></label
												><v-autocomplete
													density="compact"
													variant="outlined"
													rounded="0"
													clearable
													placeholder="Select Currency"
													:items="['USD', 'UGX', 'RWF', 'TSHS', 'KSHS']"
													v-model="budgetItem.currency"
													id="currency"
												>
												</v-autocomplete>
											</div>
										</div>
										<div class="col-md-3 required">
											<label for="date_required" class="form-label"
												><span
													v-if="budgetItem.errors.has('date_required')"
													class="text-danger text-lowercase"
												>
													{{ budgetItem.errors.get("date_required") }} </span
												><span v-else>Required Date</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												type="date"
												placeholder="Enter Date"
												v-model="budgetItem.date_required"
												id="date_required"
											></v-text-field>
										</div>
									</div>
									<div class="row mt-1">
										<div class="col-md-12 required">
											<label for="description" class="form-label"
												><span
													v-if="budgetItem.errors.has('description')"
													class="text-danger text-lowercase"
												>
													{{ budgetItem.errors.get("description") }} </span
												><span v-else>Item Detail</span></label
											>
											<v-text-field
												density="compact"
												variant="outlined"
												rounded="0"
												clearable
												placeholder="Item Description"
												v-model="budgetItem.description"
												id="description"
											></v-text-field>
										</div>
									</div>
								</div>
							</div>
						</v-card-text>

						<!-- Footer with Action Buttons -->
						<v-card-actions>
							<v-spacer>
								<!-- end of modal body -->
								<div
									class="justify-content-start modal-footer"
									style="font-family: HeaderCustomFont"
								>
									<button
										type="submit"
										class="btn bg-green-custom text-white w-10 m-2"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Save
									</button>
									<button
										type="button"
										class="btn bg-danger text-white w-10 m-2"
										@click="closeModal('items')"
									>
										<i class="far fa-save d-none"></i>&nbsp;&nbsp;Close
									</button>
								</div>
							</v-spacer>
							<!-- <v-btn color="primary" @click="tourModal = false">Close</v-btn> -->
						</v-card-actions>
					</form>
				</v-card>
			</v-dialog>
		</div>
	</content>
</template>

<script>
import config from "../../config/settings.js";
import { Errors, Form } from "vform";

export default {
	components: {},
	data() {
		return {
			api: config.API_URL,
			prefix: config.API_PFX,
			message: "",
			http_code: "",
			user: [],
			budgetModal: false,
			itemModal: false,
			selectedTour: null,
			selectedBudget: null,
			infiniteTours: [],
			infiniteBudgets: [],
			infiniteItems: [],
			infiniteTypes: [],
			infiniteVariations: [],
			filterBudgets: new Form({
				start: null,
				end: null,
				tour: null,
			}),
			tourBudget: new Form({
				id: "",
				tour_id: null,
				total_amount: "",
				status: null,
				prepared_by: "",
				reviewed_by: "",
				approved_by: "",
				rejected_by: "",
				rejection_reason: "",
				is_deleted: "",
				deleted_by: "",
				created_by: "",
				updated_by: "",
				deleted_at: "",
			}),
			budgetItem: new Form({
				id: "",
				budget_id: null,
				category: null,
				description: "",
				amount: "",
				currency: "",
				date_required: "",
				created_by: "",
				created_at: "",
				updated_by: "",
				updated_at: "",
			}),

			searchBudgeting: "",
			budgetPerPage: 10,
			budgets: [],
			budgetHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Tour Ref", value: "tour_id", sortable: true },
				{ title: "Total Amount", value: "total_amount", sortable: true },
				{ title: "Status", value: "status", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],

			searchItems: "",
			itemsPerPage: 10,
			items: [],
			itemHeaders: [
				{ title: "#", value: "index", sortable: true },
				{ title: "Category", value: "category", sortable: true },
				{ title: "Item Desc", value: "description", sortable: true },
				{ title: "Amount", value: "amount", sortable: true },
				{ title: "Currency", value: "currency", sortable: true },
				{ title: "Date Required", value: "date_required", sortable: true },
				{ title: "Actions", value: "actions", sortable: false },
			],

			openPanels: {
				filterTours: [0],
				tourPricing: [0],
				optionalCosts: [0],
				adminFees: [0],
				personBreakdown: [0],
			},
		};
	},
	methods: {
		openModal(modal, mode) {
			if (modal == "budgets") {
				if (mode == "update") {
					this.editMode = true;
					this.budgetModal = true;
				} else {
					this.editMode = false;
					this.budgetModal = true;
				}
			} else if (modal == "items") {
				if (mode == "update") {
					this.editMode = true;
					this.itemModal = true;
				} else {
					this.budgetItem.reset();
					this.budgetDetails(this.selectedBudget);
					this.editMode = false;
					this.itemModal = true;
				}
			}
		},
		closeModal(modal) {
			if (modal == "budgets") {
				this.editMode = false;
				this.budgetModal = false;
				this.tourBudget.reset();
				this.tourBudget.errors.clear();
			} else if (modal == "items") {
				this.editMode = false;
				this.itemModal = false;
				this.budgetItem.reset();
				this.budgetItem.errors.clear();
			}
		},
		async selectTour(event) {
			sessionStorage.removeItem("selected_tour");
			sessionStorage.setItem("selected_tour", JSON.stringify(event));
			this.selectedTour = event;
			this.showMessage("Tour " + event.reference_number + " selected!");
			await this.manageBudgets("None", "fetch");
		},
		async budgetDetails(event) {
			this.budgetItem.budget_id = event;
		},
		async selectBudget(event) {
			sessionStorage.removeItem("selected_budget");
			sessionStorage.setItem("selected_budget", JSON.stringify(event));
			this.selectedBudget = event;
			this.showMessage("Budget selected!");
			await this.budgetDetails(event);
			await this.manageItems("None", "fetch");
		},
		async getInfinites(mode) {
			var query, api;
			if (mode == "tours") {
				api = this.api + this.prefix + "/reservation/tours";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteTours = [];
					this.infiniteTours = query.response;
					if (this.selectedTour) {
						this.selectTour(this.selectedTour);
					} else {
						this.showMessage("No Tour Selected");
					}
				} else {
					this.showInfo(this.message, this.http_code);
				}
			} else if (mode == "items") {
				api = this.api + this.prefix + "/masters/costitem";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteItems = [];
					this.infiniteItems = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "types") {
				api = this.api + this.prefix + "/masters/costtype";
				query = await this.getData(api);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					// perform other actions
					this.infiniteTypes = [];
					this.infiniteTypes = query.response;
				} else {
					this.showError(this.message, this.http_code);
				}
			}
		},
		async manageBudgets(event, mode) {
			var query, api;
			if (mode == "fetch") {
				if (this.selectedTour !== null) {
					api =
						this.api +
						this.prefix +
						"/operations/budget/" +
						this.selectedTour.tour_id;
					query = await this.getData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					this.budgets = [];
					if (query.result == "success" && query.response.data.length > 0) {
						this.budgets = query.response;
					} else {
						this.showInfo(this.message);
					}
				}
			} else if (mode == "insert") {
				api = this.api + this.prefix + "/operations/budget";
				query = await this.postData(api, this.tourBudget);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("budgets");
					this.manageBudgets("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				api = this.api + this.prefix + "/operations/budget/" + event.id;
				query = await this.putData(api, this.tourBudget);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("budgets");
					this.manageBudgets("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.tourBudget.reset();
				this.tourBudget.fill(event);
				this.tourBudget.tour_id = event.tour;
				this.openModal("budgets", "update");
			} else {
				let confirmation = await this.showConfirmation("Delete this budget?");
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/operations/budget/" + event.id;
					query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.manageBudgets("None", "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				} else {
					this.showMessage("You've declined");
				}
			}
		},
		async manageItems(event, mode) {
			var query, api;
			if (mode == "fetch") {
				if (this.selectedBudget !== null) {
					api =
						this.api + this.prefix + "/budget-item/" + this.selectedBudget.id;
					query = await this.getData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					this.items = [];
					if (query.result == "success" && query.response.data.length > 0) {
						this.items = query.response;
					} else {
						this.showInfo(this.message);
					}
				}
			} else if (mode == "insert") {
				this.budgetItem.budget_id = this.selectedBudget;
				api = this.api + this.prefix + "/budget-item";
				query = await this.postData(api, this.budgetItem);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("items");
					this.manageItems("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "update") {
				api = this.api + this.prefix + "/budget-item/" + event.id;
				query = await this.putData(api, this.budgetItem);
				this.message = query.response.message;
				this.http_code = query.code;
				if (query.result == "success") {
					this.showMessage(this.message);
					this.closeModal("items");
					this.manageItems("None", "fetch");
				} else {
					this.showError(this.message, this.http_code);
				}
			} else if (mode == "edit") {
				this.budgetItem.reset();
				this.budgetItem.fill(event);
				this.budgetItem.budget_id = event.budget;
				this.budgetItem.category = event.category;
				this.openModal("items", "update");
			} else {
				let confirmation = await this.showConfirmation(
					"Delete this budget item?"
				);
				if (confirmation.result == "Yes") {
					api = this.api + this.prefix + "/budget-item/" + event.id;
					query = await this.deleteData(api);
					this.message = query.response.message;
					this.http_code = query.code;
					if (query.result == "success") {
						this.showMessage(this.message);
						this.manageItems("None", "fetch");
					} else {
						this.showError(this.message, this.http_code);
					}
				} else {
					this.showMessage("You've declined");
				}
			}
		},
	},
	computed: {
		currentRoute() {
			return this.$route.path.includes("/operations/");
		},
		tourSelect() {
			return (item) => {
				if (item && item.reference_number && item.client && item.agent_name) {
					return (
						item.reference_number + " (" + item.client + ") " + item.agent_name
					);
				}
			};
		},
		budgetsComputed() {
			if (this.budgets && this.budgets.data) {
				return this.budgets.data.map((budget, index) => {
					budget.index = index;
					return budget;
				});
			}
			return [];
		},
		filteredItems() {
			if (!this.items || !this.items.data) {
				return [];
			}

			// If no budget is selected, return all items
			if (!this.selectedBudget) {
				return this.items.data;
			} else {
				return this.items.data.filter(
					(item) => item.budget_id == this.selectedBudget.id
				);
			}
		},
	},
	async created() {
		await this.getInfinites("tours");

		if (this.selectedTour == null) {
			if (sessionStorage.getItem("selected_tour") !== "") {
				let selected = JSON.parse(sessionStorage.getItem("selected_tour"));
				this.selectedTour = selected;
				this.filterBudgets.tour = this.selectedTour;
				this.selectTour(selected);
			}
		}

		await this.manageBudgets("None", "fetch");

		if (this.selectedBudget == null) {
			if (sessionStorage.getItem("selected_budget") !== null) {
				let selected = JSON.parse(sessionStorage.getItem("selected_budget"));
				this.selectedBudget = selected;
				await this.selectBudget(selected);
			}
		} else {
			await this.manageItems("None", "fetch");
		}
	},
	beforeMount() {},
	mounted() {},
	unmounted() {},
	beforeUnmount() {},
};
</script>

<style scoped>
.clickable-row {
	cursor: pointer;
}

.clickable-row:hover {
	background-color: #f5f5f5 !important;
}

.selected-row td {
	background-color: lightblue !important;
}
</style>